import React, { useState, useEffect, useRef } from 'react';
import DataTable from 'react-data-table-component';
import { Modal } from 'react-bootstrap';
import { urlApiProd } from '../utiles';
import DateInput from '../../components/DateInput/DateInput';
import AgregarProducto from '../productos/AgregarProducto';
import OrdenCompraProformas from './OrdenCompraProformas';


const formatDate = (dateString) => {
  const date = new Date(dateString);
  const year = date.getUTCFullYear();
  const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
  const day = date.getUTCDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const EditarOrdenCompra = ({ ordencompra, proformas, proveedores, incoterms, puertos, productos, documentos, usuarios, categorias, especies, medidas, calidades, clientes, almacenes, guardar, cerrar }) => {
  const [botonDeshabilitado, setBotonDeshabilitado] = useState(false);
  const [emision, setEmision] = useState(ordencompra.emision ? formatDate(ordencompra.emision) : '');
  const [proforma, setProforma] = useState(ordencompra.proforma || 0);
  const [hc, setHc] = useState(ordencompra.hc ?? '');
  const [proveedor, setProveedor] = useState(ordencompra.proveedor || 0)
  const [entrega, setEntrega] = useState(ordencompra.entrega ? formatDate(ordencompra.entrega) : '');
  const [almacen, setAlmacen] = useState(ordencompra.almacen || 0);
  const [condicion_pago, setCondicionPago] = useState(ordencompra.condicion_pago || '');
  const [requisitos_calidad, setRequisitosCalidad] = useState(ordencompra.requisitos_calidad || '')
  const [requisitos_etiquetado, setRequisitosEtiquetado] = useState(ordencompra.requisitos_etiquetado || '');
  const [incoterm, setIncoTerm] = useState(ordencompra.incoterm || 0);
  const [puerto, setPuerto] = useState(ordencompra.puerto || 0);
  const [direccion_destino, setDireccionDestino] = useState(ordencompra.direccion_destino || '');
  const [descripcion_producto, setDescripcionProducto] = useState(ordencompra.descripcion_producto || '');
  const [Productos, setProductos] = useState(
    ordencompra.productos.map((producto, index) => ({
      id_producto: producto || 0,
      real_size: ordencompra.real_size[index] || '',
      m3: ordencompra.m3[index] || 0,
      usd_m3: ordencompra.usd_m3[index] || 0,
      usd_total: ordencompra.usd_total[index] || 0,
      calidad: ordencompra.calidades[index] || 0,
    }))
  );
  const [valor_ordencompra, setValorOrdenCompra] = useState(ordencompra.valor_ordencompra || 0);
  const [documentosRequeridos, SetDocumentosRequeridos] = useState(ordencompra.documentos || []);
  const [estado, setEstado] = useState(ordencompra.estado || 0);
  const [remitente, setRemitente] = useState(ordencompra.remitente || 0);
  const [aprobador, setAprobador] = useState(ordencompra.aprobador || 0);
  const [observaciones, setObservaciones] = useState(ordencompra.observaciones || '');
  const [nuevoDocumento, setNuevoDocumento] = useState(0);
  const [informacion_adicional, setInformacionAdicional] = useState(ordencompra.informacion_adicional || '')
  const [productosRequeridos, setProductosRequeridos] = useState([]);
  const [productosDisponibles, setProductosDisponibles] = useState([]);
  const [productNames, setProductNames] = useState([]);
  const [productSearchTerm, setProductSearchTerm] = useState('');
  const [showProductSearchDropdown, setShowProductSearchDropdown] = useState(false);
  const productSearchDropdownRef = useRef(null);
  const [productoSeleccionado, setProductoSeleccionado] = useState(null);
  const [calidadSeleccionada, setCalidadSeleccionada] = useState(null);
  const [showAgregarProducto, setShowAgregarProducto] = useState(false);
  const [indicadorIT, setIndicadorIT] = useState(null)
  const [origen, setOrigen] = useState(ordencompra.origen || 'Brazil');
  const [allowance, setAllowance] = useState(ordencompra.allowance || 0);
  const [moneda, setMoneda] = useState(ordencompra.moneda || 0);
  const [editMode, setEditMode] = useState(false);
  const [productoEnEdicion, setProductoEnEdicion] = useState(null);
  const [correlativo, setCorrelativo] = useState(ordencompra.correlativo || 0);
  const [id_oc, setIdOc] = useState(ordencompra.id_oc || '');
  const [empresaEmisor, setEmpresaEmisor] = useState(ordencompra.empresa_emisor || '');
  const [m3, setM3] = useState('');
  const [usdM3, setUsdM3] = useState('');

  useEffect(() => {
    if (incoterm) {
      seleccionIT(incoterm);
    }
  }, [incoterm]);

  const fetchProductNames = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await fetch(`${urlApiProd}/nombreproductos_ordencompra`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.ok) {
        const data = await response.json();
        const uniqueProducts = [];
        const seenIds = new Set();
        data.forEach((item) => {
          const id = item.id_producto;
          if (id != null && id !== '' && !seenIds.has(Number(id))) {
            seenIds.add(Number(id));
            uniqueProducts.push(item);
          }
        });
        setProductNames(uniqueProducts);
        return uniqueProducts;
      }
    } catch (error) {
      console.error('Error al obtener nombres de productos:', error);
    }
    return [];
  };

  useEffect(() => {
    fetchProductNames();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (productSearchDropdownRef.current && !productSearchDropdownRef.current.contains(event.target)) {
        setShowProductSearchDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (productos && productos.length) {
      setProductosDisponibles(productos);
    }
  }, [productos]);

  useEffect(() => {
    const prov = proveedores.find((p) => parseInt(p.id_proveedor, 10) === parseInt(proveedor, 10));
    if (prov?.productos?.length) {
      setProductosRequeridos(prov.productos.map((x) => parseInt(x, 10)));
    } else if (productos?.length) {
      setProductosRequeridos(productos.map((p) => parseInt(p.id_producto, 10)));
    } else {
      setProductosRequeridos([]);
    }
  }, [proveedor, proveedores, productos]);

  const idProductoPermitidoParaOc = (idProducto) => {
    const id = parseInt(idProducto, 10);
    if (!id) return false;
    const enDisponibles = productosDisponibles.some((p) => parseInt(p.id_producto, 10) === id);
    if (!enDisponibles) return false;
    if (!productosRequeridos || productosRequeridos.length === 0) return true;
    return productosRequeridos.some((r) => parseInt(r, 10) === id);
  };

  const normalizarTextoBusqueda = (s) => (s || '').toLowerCase().trim().replace(/\s+/g, ' ');
  const coincideBusquedaProducto = (texto, termNormalizado) => {
    if (!termNormalizado) return true;
    const t = texto;
    if (t.includes(termNormalizado)) return true;
    const tokens = termNormalizado.split(' ').filter(Boolean);
    if (tokens.length <= 1) return false;
    return tokens.every((tok) => t.includes(tok));
  };
  const nombreProductosFiltrados = productNames.filter((p) => {
    if (!idProductoPermitidoParaOc(p.id_producto)) return false;
    const term = normalizarTextoBusqueda(productSearchTerm);
    if (!term) return true;
    const nombre = normalizarTextoBusqueda(p.nombre_producto || '');
    const cal = normalizarTextoBusqueda(p.calidad || '');
    return coincideBusquedaProducto(nombre, term) || coincideBusquedaProducto(cal, term);
  });

  useEffect(() => {
    if (!editMode || !productoSeleccionado) return;
    const m = productNames.find(
      (n) => parseInt(n.id_producto, 10) === parseInt(productoSeleccionado, 10)
    );
    if (m) setProductSearchTerm(m.nombre_producto);
  }, [editMode, productoSeleccionado, productNames]);

  const getCurrencySymbol = (moneda) => {
    switch (moneda) {
      case 0: return 'USD';
      case 1: return 'EUR';
      case 2: return 'CLP';
      case 3: return 'BRL';
      case 4: return 'PYG';
      default: return 'USD';
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!parseInt(hc, 10) || parseInt(hc, 10) <= 0) {
      alert('Ingrese el HC (cantidad de contenedores High Cube).');
      return;
    }
    setBotonDeshabilitado(true);

    const arrayProductos = [];
    const arrayRealSize = [];
    const arrayM3 = [];
    const arrayUSDM3 = [];
    const arrayUSDTotal = [];
    const arrayCalidad = [];

    Productos.forEach(producto => {
      arrayProductos.push(producto.id_producto)
      arrayRealSize.push(producto.real_size)
      arrayM3.push(producto.m3)
      arrayUSDM3.push(producto.usd_m3)
      arrayUSDTotal.push(producto.usd_total)
      arrayCalidad.push(parseInt(producto.calidad, 10));
    })

    const arrayDocumentos = []

    documentosRequeridos.forEach(doc => {
      arrayDocumentos.push(doc)
    })

    const edited = {
      id_ordencompra: ordencompra.id_ordencompra,
      proveedor,
      proforma,
      hc: parseInt(hc, 10),
      almacen,
      emision,
      entrega,
      incoterm,
      puerto,
      productos: arrayProductos,
      real_size: arrayRealSize,
      m3: arrayM3,
      usd_m3: arrayUSDM3,
      usd_total: arrayUSDTotal,
      documentos: arrayDocumentos,
      valor_ordencompra,
      condicion_pago,
      requisitos_calidad,
      informacion_adicional,
      requisitos_etiquetado,
      estado: estado < 2 ? 2 : estado,
      remitente,
      aprobador,
      observaciones,
      descripcion_producto,
      calidades: arrayCalidad,
      origen,
      allowance,
      moneda,
      correlativo,
      id_oc,
      empresa_emisor: parseInt(empresaEmisor),
    }

    guardar(edited);
    cerrar();
  }

  const columnsProductos = [
    {
      name: 'Producto',
      selector: row => {
        if (!row.id_producto) return '';
        const productoEncontrado =
          productos.find((prod) => parseInt(prod.id_producto, 10) === parseInt(row.id_producto, 10)) ||
          productosDisponibles.find((prod) => parseInt(prod.id_producto, 10) === parseInt(row.id_producto, 10));
        if (productoEncontrado) {
          const categoriaEncontrada = categorias.find(
            (categoria) => parseInt(categoria.id_categoria, 10) === parseInt(productoEncontrado.categoria, 10)
          );
          const especieEncontrada = especies.find(
            (especie) => parseInt(especie.id_especie, 10) === parseInt(productoEncontrado.especie, 10)
          );
          const medidaEncontrada = medidas.find(
            (medida) => parseInt(medida.id_medida, 10) === parseInt(productoEncontrado.medida, 10)
          );
          if (categoriaEncontrada && especieEncontrada && medidaEncontrada) {
            const espMostrar = productoEncontrado.espesor;
            return (
              categoriaEncontrada.nombre +
              ' de ' +
              especieEncontrada.nombre +
              ' ' +
              espMostrar +
              ' X ' +
              medidaEncontrada.ancho +
              ' X ' +
              medidaEncontrada.largo
            );
          }
        }
        const nomOc = productNames.find(
          (n) => parseInt(n.id_producto, 10) === parseInt(row.id_producto, 10)
        );
        return nomOc?.nombre_producto || '';
      },
    },
    {
      name: 'Calidad',
      selector: row => {
        if (row.calidad) {
          const calidadEncontrada = calidades.find(cal => parseInt(cal.id_calidad) === parseInt(row.calidad));
          if (calidadEncontrada) {
            return calidadEncontrada.calidad;
          }
        } else {
          return row.calidad
        }
      },
      width: '15%',
    },
    {
      name: 'Real Size',
      selector: row => row.real_size,
      width: '15%',
    },
    {
      name: 'm3',
      selector: row => row.m3,
      width: '15%',
    },
    {
      name: `${getCurrencySymbol(moneda)}/m3`,
      selector: row => row.usd_m3,
      width: '15%',
    },
    {
      name: `Total ${getCurrencySymbol(moneda)}`,
      selector: row => row.usd_total,
      width: '15%',
    },
    {
      name: 'Editar',
      cell: row => (
        <button
          type="button"
          className="btn btn-outline-primary"
          onClick={() => handleEditProducto(row)}
        >
          Editar
        </button>
      ),
      ignoreRowClick: true,
      width: '100px',
    },
    {
      name: 'Eliminar',
      cell: row => (
        <div className="delete-button-container">
          <button
            type="button"
            className="btn btn-outline-danger delete-button"
            onClick={() => {
              if (window.confirm('¿Estás seguro?')) {
                handleDeleteProducto(row.id_producto, row.calidad);
              }
            }}
          >
            X
          </button>
        </div>
      ),
      ignoreRowClick: true,
      width: '100px',
    },
  ];

  const columnsDocumentos = [
    {
      name: 'Documentos',
      selector: row => {
        if (row) {
          const docEncontrado = documentos.find(d => parseInt(d.id_documento) === parseInt(row));
          if (docEncontrado) {
            return docEncontrado.nombre
          }
        }
      },
    },
    {
      name: 'Eliminar',
      cell: row => (
        <div className="delete-button-container">
          <button
            type="button"
            className="btn btn-outline-danger delete-button"
            onClick={() => {
              if (window.confirm('¿Estás seguro?')) {
                handleDeleteDocumento(row)
              }
            }}
          >
            X
          </button>
        </div>
      ),
      ignoreRowClick: true,
      width: '100px',
    },
  ];

  const handleEditProducto = (producto) => {
    setProductoSeleccionado(producto.id_producto);
    setCalidadSeleccionada(producto.calidad);
    setM3(producto.m3);
    setUsdM3(producto.usd_m3);
    setEditMode(true);
    setProductoEnEdicion(producto);
    const np = productNames.find(
      (n) => parseInt(n.id_producto, 10) === parseInt(producto.id_producto, 10)
    );
    if (np) setProductSearchTerm(np.nombre_producto);
  };

  const handleDeleteProducto = (id_producto, calidad) => {
    const updatedProductos = Productos.filter(
      (producto) => producto.id_producto !== id_producto || String(producto.calidad) !== String(calidad)
    );
    if (updatedProductos.length !== Productos.length) {
      setProductos(updatedProductos);
      if (updatedProductos.length === 0) {
        setDescripcionProducto('');
      }
    }
  };

  const handleAgregarProducto = () => {
    if (productoSeleccionado) {
      const producto = productosDisponibles.find(
        (prod) => parseInt(prod.id_producto, 10) === parseInt(productoSeleccionado, 10)
      );

      if (producto) {
        if (!m3 || !usdM3) {
          alert('Por favor ingrese todos los detalles requeridos (m3, Precio).');
          return;
        }

        if (editMode && productoEnEdicion) {
          const updatedProductos = Productos.map((prod) => {
            if (
              prod.id_producto === productoEnEdicion.id_producto &&
              String(prod.calidad) === String(productoEnEdicion.calidad)
            ) {
              return {
                ...prod,
                m3: parseFloat(parseFloat(m3).toFixed(3)),
                usd_m3: parseFloat(parseFloat(usdM3).toFixed(3)),
                usd_total: parseFloat((parseFloat(m3) * parseFloat(usdM3)).toFixed(3)),
              };
            }
            return prod;
          });
          setProductos(updatedProductos);
          setEditMode(false);
          setProductoEnEdicion(null);
          setM3('');
          setUsdM3('');
          setProductoSeleccionado(null);
          setCalidadSeleccionada('');
          setProductSearchTerm('');
          alert('Producto actualizado exitosamente.');
        } else {
          const categoriaSeleccionada = categorias.find(
            (categoria) => parseInt(categoria.id_categoria, 10) === parseInt(producto.categoria, 10)
          );
          const especieSeleccionada = especies.find(
            (especie) => parseInt(especie.id_especie, 10) === parseInt(producto.especie, 10)
          );
          const medidaEncontrada = medidas.find((m) => m.id_medida === producto.medida);

          if (medidaEncontrada && categoriaSeleccionada && especieSeleccionada) {
            const indiceEspesor = medidaEncontrada.espesor.findIndex((e) => e === producto.espesor);

            if (indiceEspesor !== -1) {
              const espesorrCorrespondiente = medidaEncontrada.espesorr[indiceEspesor];

              const nuevo = {
                id_producto: parseInt(producto.id_producto, 10),
                real_size: `${espesorrCorrespondiente} x ${medidaEncontrada.anchor} x ${medidaEncontrada.largor}`,
                m3: parseFloat(parseFloat(m3).toFixed(3)),
                usd_m3: parseFloat(parseFloat(usdM3).toFixed(3)),
                usd_total: parseFloat((parseFloat(m3) * parseFloat(usdM3)).toFixed(3)),
                calidad: parseInt(producto.id_calidad, 10),
              };

              setProductos([...Productos, nuevo]);
              setDescripcionProducto(
                `${categoriaSeleccionada.nombre_portugues} ${especieSeleccionada.nombre_portugues}`
              );
              setM3('');
              setUsdM3('');
              alert('Producto Agregado');
            } else {
              alert('El espesor seleccionado no coincide con ningún espesorr disponible.');
            }
          } else {
            alert('Medida no encontrada.');
          }
        }
      } else {
        alert('Debe seleccionar un producto.');
      }
    } else {
      alert('Producto no seleccionado.');
    }
  };

  useEffect(() => {
    if (!editMode) {
      setCalidadSeleccionada('');
      setM3('');
      setUsdM3('');
    }
  }, [productoSeleccionado, editMode]);

  useEffect(() => {
    const totalUSD = Productos.reduce((acc, producto) => acc + parseFloat(producto.usd_total || 0), 0);
    setValorOrdenCompra(totalUSD.toFixed(3));
  }, [Productos]);

  const handleDeleteDocumento = (id) => {
    const updatedDocumentos = documentosRequeridos.filter((doc) => doc !== id);
    SetDocumentosRequeridos(updatedDocumentos);
  };

  const handleAgregarDocumento = () => {
    if (nuevoDocumento) {
      const documentoSeleccionado = documentos.find(d => parseInt(d.id_documento) === parseInt(nuevoDocumento));
      if (documentoSeleccionado) {
        const nuevo = documentoSeleccionado.id_documento
        SetDocumentosRequeridos([...documentosRequeridos, nuevo]);
        setNuevoDocumento(null);
      } else {
        alert("No se puede agregar");
      }
    }
  }

  const handleSelectChange = (e) => {
    const value = e.target.value;
    setProforma(value);
  };

  const seleccionIT = (incoterm) => {
    if (incoterm !== 0) {
      const itSeleccionado = incoterms.find(i => i.id_incoterm === parseInt(incoterm))
      if (itSeleccionado) {
        if (itSeleccionado.indicador === 1) {
          setIncoTerm(itSeleccionado.id_incoterm)
          setIndicadorIT(1);
        } else if (itSeleccionado.indicador === 2) {
          setIncoTerm(itSeleccionado.id_incoterm)
          setIndicadorIT(2);
        } else if (itSeleccionado.indicador === 3) {
          setIncoTerm(itSeleccionado.id_incoterm)
          setIndicadorIT(3);
        } else {
          console.log("Error con el indicador")
        }
      } else {
        console.log("No se encontro el incoterm")
      }
    }
  }

  return (
    <div className='modal-overlay'>
      <div className='modal1'>
        <div className='card'>
          <form onSubmit={handleSubmit}>
            <div className='card-header'>
              <div className='card-title' style={{ textAlign: 'center' }}>
                <strong>
                  Editar Orden de compra {ordencompra.id_oc ? (ordencompra.id_oc + (ordencompra.editado > 0 ? ` Ad. ${ordencompra.editado}` : '')) : (
                    `${proveedores.find(p => p.id_proveedor === ordencompra.proveedor)?.siglas} ${correlativo < 10 ? '0' + correlativo : correlativo}-${new Date(ordencompra.entrega).getUTCFullYear().toString().substr(-2)}` + (ordencompra.editado > 0 ? ` Ad. ${ordencompra.editado}` : '')
                  )}
                </strong>
              </div>
            </div>
            <div className='card-body'>
              <div className="input-group mb-3">
                <span className='input-group-text'>Moneda</span>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="moneda"
                    id="usd"
                    value={0}
                    checked={moneda === 0}
                    onChange={(e) => setMoneda(parseInt(e.target.value))}
                  />
                  <label className="form-check-label" htmlFor="usd">USD</label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="moneda"
                    id="eur"
                    value={1}
                    checked={moneda === 1}
                    onChange={(e) => setMoneda(parseInt(e.target.value))}
                  />
                  <label className="form-check-label" htmlFor="eur">EUR</label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="moneda"
                    id="clp"
                    value={2}
                    checked={moneda === 2}
                    onChange={(e) => setMoneda(parseInt(e.target.value))}
                  />
                  <label className="form-check-label" htmlFor="clp">CLP</label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="moneda"
                    id="brl"
                    value={3}
                    checked={moneda === 3}
                    onChange={(e) => setMoneda(parseInt(e.target.value))}
                  />
                  <label className="form-check-label" htmlFor="brl">BRL</label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="moneda"
                    id="pyg"
                    value={4}
                    checked={moneda === 4}
                    onChange={(e) => setMoneda(parseInt(e.target.value))}
                  />
                  <label className="form-check-label" htmlFor="pyg">PYG</label>
                </div>
              </div>
              <div className="input-group mb-3">
                <span className='input-group-text'>Empresa Emisor</span>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="empresaEmisor"
                    id="ptc"
                    value={0}
                    checked={empresaEmisor === 0}
                    onChange={(e) => setEmpresaEmisor(parseInt(e.target.value))}
                  />
                  <label className="form-check-label" htmlFor="ptc">PTC</label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="empresaEmisor"
                    id="ptb"
                    value={1}
                    checked={empresaEmisor === 1}
                    onChange={(e) => setEmpresaEmisor(parseInt(e.target.value))}
                  />
                  <label className="form-check-label" htmlFor="ptb">PTB</label>
                </div>
              </div>
              <div className="input-group mb-3">
                <span className="input-group-text">Proforma</span>
                <select
                  className="form-select"
                  value={proforma}
                  onChange={(e) => handleSelectChange(e)}
                  disabled={proforma !== 0}  // Deshabilitar si ya hay una proforma seleccionada
                >
                  <option value="">Seleccione una Proforma</option>
                  <option value={0}>Proforma por crear</option>
                  {proformas.map((Pi) => {
                    const clienteExistente = clientes.find(cli => cli.id_cliente === Pi.cliente);
                    if (clienteExistente) {
                      return (
                        <option key={Pi.id_proforma} value={Pi.id_proforma}>
                          {Pi.id_pi ? Pi.id_pi : (
                            `${clienteExistente?.siglas} ${parseInt(Pi.correlativo) < 10 ? '0' + Pi.correlativo : Pi.correlativo}-${isNaN(new Date(Pi.fecha_embarque).getUTCFullYear())
                              ? '00'
                              : new Date(Pi.fecha_embarque).getUTCFullYear().toString().substr(-2)}`
                          )} - {clienteExistente?.nombre}
                        </option>
                      );
                    }
                    return null;
                  })}
                </select>
              </div>
              <div className="input-group mb-3">
                <span className="input-group-text">HC</span>
                <input
                  type="number"
                  min="1"
                  step="1"
                  className="form-control"
                  placeholder="Ingrese cantidad de contenedores High Cube"
                  value={hc}
                  onChange={(e) => setHc(e.target.value)}
                  required
                />
              </div>
              <OrdenCompraProformas ordencompra={ordencompra} proformas={proformas} clientes={clientes} />
              <div className='input-group mb-3'>
                <span className='input-group-text'>Fecha de Emisión</span>
                <DateInput
                  value={emision}
                  onChange={(e) => setEmision(e.target.value)}
                />
              </div>
              <div className="input-group mb-3">
                <span className='input-group-text'>Proveedor</span>
                <select
                  className="form-select"
                  value={proveedor}
                  onChange={(e) => setProveedor(e.target.value)}
                  disabled
                >
                  <option value="">Seleccione un proveedor</option>
                  {proveedores.map((pro) => (
                    <option key={pro.id_proveedor} value={pro.id_proveedor}>
                      {pro.nombre}
                    </option>
                  ))}
                </select>
              </div>
              <div className='input-group mb-3'>
                <span className='input-group-text'>Fecha Embarque</span>
                <DateInput
                  value={entrega}
                  onChange={(e) => setEntrega(e.target.value)}
                />
              </div>
              <div className='input-group mb-3'>
                <span className='input-group-text'>Origen</span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Ingrese Origen"
                  value={origen}
                  onChange={(e) => setOrigen(e.target.value)}
                  required
                />
              </div>
              <div className="input-group mb-3">
                <span className="input-group-text">IncoTerm</span>
                <select
                  className="form-select"
                  value={incoterm}
                  onChange={(e) => seleccionIT(e.target.value)}
                >
                  <option value="">Seleccione un IncoTerm</option>
                  {incoterms.map((it) => (
                    <option key={it.id_incoterm} value={it.id_incoterm}>
                      {it.nombre}
                    </option>
                  ))}
                </select>
              </div>
              {indicadorIT === 2 &&
                <div className="input-group mb-3">
                  <span className="input-group-text">Almacén</span>
                  <select
                    className="form-select"
                    value={almacen}
                    onChange={(e) => setAlmacen(e.target.value)}
                  >
                    <option value="">Seleccione un almacén</option>
                    {almacenes.map((alm) => (
                      <option key={alm.id_almacen} value={alm.id_almacen}>
                        {alm.nombre}
                      </option>
                    ))}
                  </select>
                </div>
              }
              {indicadorIT === 1 &&
                <div className="input-group mb-3">
                  <span className="input-group-text">Puerto</span>
                  <select
                    className="form-select"
                    value={puerto}
                    onChange={(e) => setPuerto(e.target.value)}
                  >
                    <option value="">Seleccione un Puerto de Destino</option>
                    {puertos.map((puerto) => (
                      <option key={puerto.id_puerto} value={puerto.id_puerto}>
                        {puerto.nombre}
                      </option>
                    ))}
                  </select>
                </div>
              }
              <div className="input-group mb-3">
                <span className="input-group-text">Descripción Producto</span>
                <input
                  type="text"
                  className="form-control"
                  value={descripcion_producto}
                  readOnly
                />
              </div>
              <div className='mb-3'>
                <h5 style={{ textAlign: 'center' }}>Productos</h5>
                <div className="mb-3 position-relative" ref={productSearchDropdownRef} style={{ zIndex: 20 }}>
                  <label className="form-label fw-bold">Selecciona un producto:</label>
                  <div className="input-group">
                    <span className="input-group-text"><i className="bi bi-search text-primary"></i></span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Escribe el nombre de un producto..."
                      value={productSearchTerm}
                      onChange={(e) => {
                        setProductSearchTerm(e.target.value);
                        setShowProductSearchDropdown(true);
                      }}
                      onFocus={() => setShowProductSearchDropdown(true)}
                      style={{ borderLeft: 'none' }}
                      disabled={editMode}
                    />
                    {productoSeleccionado && !editMode && (
                      <button
                        type="button"
                        className="btn btn-outline-danger"
                        onClick={() => {
                          setProductoSeleccionado(null);
                          setProductSearchTerm('');
                        }}
                      >
                        <i className="bi bi-x-circle"></i> Limpiar
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn btn-outline-success"
                      onClick={() => setShowAgregarProducto(true)}
                      disabled={editMode}
                    >
                      Crear Producto
                    </button>
                  </div>
                  {showProductSearchDropdown && !editMode && (
                    <div
                      className="list-group position-absolute w-100 shadow-lg"
                      style={{ zIndex: 1050, maxHeight: '250px', overflowY: 'auto', top: '100%' }}
                    >
                      {nombreProductosFiltrados.map((p, idx) => (
                        <button
                          key={`${p.id_producto}-${idx}`}
                          type="button"
                          className="list-group-item list-group-item-action text-start"
                          onClick={() => {
                            setProductoSeleccionado(parseInt(p.id_producto, 10));
                            setProductSearchTerm(p.nombre_producto);
                            setShowProductSearchDropdown(false);
                          }}
                        >
                          <span className="fw-medium">{p.nombre_producto}</span>
                        </button>
                      ))}
                      {nombreProductosFiltrados.length === 0 && (
                        <div className="list-group-item disabled text-muted fst-italic">
                          {productSearchTerm.trim()
                            ? 'No se encontraron productos coincidentes'
                            : 'No hay productos disponibles para este proveedor'}
                        </div>
                      )}
                    </div>
                  )}
                  {productoSeleccionado && !editMode && (
                    <div className="mt-2 p-2 bg-light rounded border-start border-success border-4 d-flex align-items-center">
                      <i className="bi bi-check-circle-fill text-success me-2" style={{ fontSize: '1.2rem' }}></i>
                      <div>
                        <small className="text-muted d-block">Producto seleccionado:</small>
                        <span className="fw-bold text-success">{productSearchTerm}</span>
                      </div>
                    </div>
                  )}
                </div>
                <div className="input-group mb-3">
                  <span className="input-group-text">m3</span>
                  <input
                    type="number"
                    id="m3"
                    className="form-control"
                    value={m3}
                    onChange={(e) => setM3(e.target.value)}
                  />
                  <span className="input-group-text">{getCurrencySymbol(moneda)}/m3</span>
                  <input
                    type="number"
                    id="usd_m3"
                    className="form-control"
                    value={usdM3}
                    onChange={(e) => setUsdM3(e.target.value)}
                  />
                </div>
                <button
                  type="button"
                  onClick={handleAgregarProducto}
                  className="btn btn-outline-primary"
                  disabled={!productoSeleccionado || !m3 || !usdM3}
                >
                  {editMode ? 'Editar Producto' : 'Agregar Producto'}
                </button>
                <DataTable
                  columns={columnsProductos}
                  data={Productos}
                  highlightOnHover
                  dense
                  pagination={true}
                />
              </div>
              <div className="input-group mb-3">
                <span className="input-group-text">Valor Orden de Compra (${getCurrencySymbol(moneda)})</span>
                <input
                  type="text"
                  className="form-control"
                  value={valor_ordencompra}
                  readOnly
                />
              </div>
              <div className="input-group mb-3">
                <span className="input-group-text" style={{ width: '170px' }}>Allowance</span>
                <textarea
                  type="number"
                  className="form-control"
                  placeholder="Ingrese condiciones de pago"
                  value={allowance}
                  onChange={(e) => setAllowance(e.target.value)}
                  required
                />
              </div>
              <div className="input-group mb-3">
                <span className="input-group-text" style={{ width: '170px' }}>Condición de Pago</span>
                <textarea
                  type="text"
                  className="form-control"
                  placeholder="Ingrese condiciones de pago"
                  value={condicion_pago}
                  onChange={(e) => setCondicionPago(e.target.value)}
                  required
                />
              </div>
              <div className="input-group mb-3">
                <span className="input-group-text" style={{ width: '170px' }}>Requisitos Calidad</span>
                <textarea
                  type="text"
                  className="form-control"
                  placeholder="Ingrese Requisitos de calidad"
                  value={requisitos_calidad}
                  onChange={(e) => setRequisitosCalidad(e.target.value)}
                  required
                />
              </div>
              <div className="input-group mb-3">
                <span className="input-group-text" style={{ width: '170px' }}>Información Adicional</span>
                <textarea
                  type="text"
                  className="form-control"
                  placeholder="Ingrese Requisitos de etiquetado"
                  value={informacion_adicional}
                  onChange={(e) => setInformacionAdicional(e.target.value)}
                  required
                />
              </div>
              <div className="input-group mb-3">
                <span className="input-group-text" style={{ width: '170px' }}>Requisitos Etiquetado</span>
                <textarea
                  type="text"
                  className="form-control"
                  placeholder="Ingrese Requisitos de etiquetado"
                  value={requisitos_etiquetado}
                  onChange={(e) => setRequisitosEtiquetado(e.target.value)}
                  required
                />
              </div>
              <div className="mb-3">
                <h5 style={{ textAlign: 'center' }}>Documentos Requeridos</h5>
                <div className="input-group mb-3">
                  <span className="input-group-text">Documento</span>
                  <select
                    value={nuevoDocumento}
                    onChange={e => setNuevoDocumento(e.target.value)}
                    className="form-control"
                  >
                    <option value="">Seleccionar Documento</option>
                    {documentos.map((td) => {
                      const tdExistente = documentosRequeridos.some(dr => parseInt(dr) === parseInt(td.id_documento));
                      if (!tdExistente) {
                        return (
                          <option key={td.id_documento} value={td.id_documento}>
                            {td.nombre}
                          </option>
                        );
                      }
                      return null;
                    })}
                  </select>
                  <button type="button" onClick={handleAgregarDocumento} className="btn btn-outline-primary" disabled={!nuevoDocumento}>
                    Agregar Documento
                  </button>
                </div>
                <DataTable
                  columns={columnsDocumentos}
                  data={documentosRequeridos}
                  highlightOnHover
                  dense
                  pagination={true}
                />
              </div>
              <div className="input-group mb-3">
                <span className="input-group-text">Remitente</span>
                <select
                  className="form-select"
                  value={remitente}
                  onChange={(e) => setRemitente(e.target.value)}
                >
                  <option value="">Seleccione un Remitente</option>
                  {usuarios.map((user) => (
                    <option key={user.id_usuario} value={user.id_usuario}>
                      {user.nombre}
                    </option>
                  ))}
                </select>
              </div>
              <div className="input-group mb-3">
                <span className="input-group-text">Aprobador</span>
                <select
                  className="form-select"
                  value={aprobador}
                  onChange={(e) => setAprobador(e.target.value)}
                >
                  <option value="">Seleccione un Aprobador</option>
                  {usuarios
                    .filter(user => user.rol === 1)
                    .map(user => (
                      <option key={user.id_usuario} value={user.id_usuario}>
                        {user.nombre}
                      </option>
                    ))}
                </select>
              </div>
              <div className="input-group mb-3">
                <span className="input-group-text">Observaciones</span>
                <textarea
                  type="text"
                  className="form-control"
                  value={observaciones}
                  onChange={(e) => setObservaciones(e.target.value)}
                />
              </div>
            </div>
            <div className='card-footer' style={{ textAlign: 'center' }}>
              <button
                type="submit"
                className="btn btn-outline-success mb-3 mt-3"
                disabled={botonDeshabilitado}
              >
                Guardar
              </button>
              <button type="button" className="btn btn-outline-danger" onClick={cerrar}>Cancelar</button>
            </div>
          </form>
        </div>
      </div>
      <Modal show={showAgregarProducto} onHide={() => setShowAgregarProducto(false)} size="lg" style={{ zIndex: 11000 }}>
        <Modal.Header closeButton>
          <Modal.Title>Crear Producto</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AgregarProducto
            cerrar={async (nuevo) => {
              setShowAgregarProducto(false);
              if (nuevo && nuevo.id_producto) {
                const productoConTiposCorrectos = {
                  ...nuevo,
                  id_producto: parseInt(nuevo.id_producto, 10),
                  categoria: parseInt(nuevo.categoria, 10),
                  especie: parseInt(nuevo.especie, 10),
                  medida: parseInt(nuevo.medida, 10),
                };
                setProductosDisponibles((prev) => [...prev, productoConTiposCorrectos]);
                setProductoSeleccionado(parseInt(productoConTiposCorrectos.id_producto, 10));
                setProductosRequeridos((prev) => [...prev, parseInt(productoConTiposCorrectos.id_producto, 10)]);
                const lista = await fetchProductNames();
                const byId = lista.find(
                  (item) => parseInt(item.id_producto, 10) === parseInt(productoConTiposCorrectos.id_producto, 10)
                );
                setProductSearchTerm(byId?.nombre_producto || '');
              }
            }}
            opciones={{ categorias, especies, calidades, medidas }}
            medidas={medidas}
          />
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default EditarOrdenCompra